import { Alert, Title } from "@mantine/core";

import { AppLayout } from "@/components/AppLayout";
import { t } from "@/i18n";

/**
 * Shown on a portal route when the server-side permission resolve FAILED.
 *
 * The portal is gated on a permission resolved from IAM, so an IAM or BFF outage
 * would otherwise present a real client admin with the not-found page, which reads
 * as "this does not exist for you" and sends them to the wrong fix. We do not know
 * what they hold, so we say that instead.
 */
export function PortalPermissionsUnavailablePage(): JSX.Element {
  return (
    <AppLayout breadcrumbs={[{ label: t("portal.title") }]}>
      <Title order={1}>{t("portal.permissions_unavailable_title")}</Title>
      <Alert color="yellow" mt="md">
        {t("portal.permissions_unavailable_body")}
      </Alert>
    </AppLayout>
  );
}
